import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ProductSelectionPartsModel } from "@tCooneyBrothers/ApiModels";
import { getProductSelectionParts } from "@tCooneyBrothers/Services/ProductSelectionPartsService";
import { CustomApiHandler, CustomHandlerWithResult } from "@tCooneyBrothers/Store/CustomHandlerCreator";

export interface ProductSelectionPartsParameter {
    productId: string;
}

type HandlerType = CustomHandlerWithResult<
    ProductSelectionPartsParameter,
    {
        apiResult: ProductSelectionPartsModel[] | void;
    },
    {}
>;

export const DispatchBeginLoadProductSelectionParts: HandlerType = props => {
    props.dispatch({
        type: "Data/ProductSelectionParts/BeginLoadProductSelectionParts",
        parameter: props.parameter,
    });
};

// export const PopulateApiParameter: HandlerType = props => {
//     props.apiParameter = { ...props.parameter };
// };

export const RequestDataFromApi: HandlerType = async props => {
    try {
        // eslint-disable-next-line no-console
        console.log("inside load ProductSelectionParts", props);
        props.result = {
            apiResult: await getProductSelectionParts(props.parameter.productId),
        };
        // eslint-disable-next-line no-empty
    } catch (error) {}
};

export const DispatchCompleteLoadProductSelectionParts: HandlerType = props => {
    // eslint-disable-next-line no-console
    console.log("DispatchCompleteLoadProductSelectionParts", props.result.apiResult);
    props.dispatch({
        type: "Data/ProductSelectionParts/CompleteLoadProductSelectionParts",
        action: props.result.apiResult || [],
    });
};

export const chain = [
    // PopulateApiParameter,
    DispatchBeginLoadProductSelectionParts,
    RequestDataFromApi,
    DispatchCompleteLoadProductSelectionParts,
];

const loadProductSelectionParts = createHandlerChainRunner(chain, "LoadProductSelectionParts");
export default loadProductSelectionParts;
